import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { CompanyUserQuery } from 'interfaceAdapter/queries/CompanyUser';
import { companyUserContext } from 'application/contexts/useCompanyUser';
import { PROFILE_STAGE } from 'domain/entities/CompanyUser/CompanyUser';

/**
 * 認証状態の確認と、ログイン後ページの共通処理
 */
export const useCompanyStandard = () => {
    const mainRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const companyUserQuery = diContainer.resolve(CompanyUserQuery);
    const { setUser } = useContext(companyUserContext);
    const [canEnter, setCanEnter] = useState(false);
    const [isSideOpen, setIsSideOpen] = useState(true);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.scrollTop = 0;
        }
        const checkCanEnter = async () => {
            const { user, status } = await companyUserQuery.checkToken(false);
            if (status !== false) {
                setUser(user);
                if (user.account_profile_stage === PROFILE_STAGE.ONLY_PASSWORD) {
                    navigate('/company/registration/company_profile/');
                }
                setCanEnter(true);
            } else {
                // 有効なトークンが無いのでリダイレクト
                navigate('/company/login/');
            }
        };
        checkCanEnter();
    }, [window.location]);

    return { mainRef, canEnter, isSideOpen, setIsSideOpen };
};
